import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

const styles = theme => ({
  iconRoot: {
    width: '1rem',
    height: '1rem',
    color: theme.palette.accent3.main,
    marginRight: '0.5rem',
  },
  span: {
    color: theme.palette.secondary.text,
    marginTop: '4px',
    marginBottom: '3px',
    fontSize: '0.75rem',
    display: 'block',
  },
});

const Error = ({
  error, classes,
}) => (
  <React.Fragment>
    {error &&
      <span className={classes.span}>
        <ErrorOutlineOutlinedIcon classes={{ root: classes.iconRoot }} />{error}
      </span>
    }
  </React.Fragment>
);

Error.propTypes = {
  error: PropTypes.string,
  classes: PropTypes.element.isRequired,
};

Error.defaultProps = {
  error: null,
};

export default withStyles(styles)(Error);
